var $ = require('jquery');
var _debounce = require('lodash/debounce');

$(function () {
    var parallaxDivClassName = "parallax-div";
    var parallaxMobileDivClassName = "parallax-mobile-div";
    var $parallaxDivs = $("." + parallaxDivClassName);
    var $parallaxMobileDivs = $("." + parallaxMobileDivClassName);
    var images = {};

    //On Page Load Run Parallax algorithim to set background-y height and prevent jumping on initial scroll.
    reCalculateImageHeight();

    //On Window Resize debounce so that the image only updates one time. This has to be separate from the scroll
    //event otherwise the parallax does not work properly.
    $(window).on("resize",
        _debounce(function () {
            reCalculateImageHeight();
        }, 200));

    //Get the div background images
    $(window).on("scroll",
        function () {
            GetDivElements();
        });

    function reCalculateImageHeight() {
        $parallaxDivs.each(function (index, element) { setBackgroundDataSource(element); });
        $parallaxMobileDivs.each(function (index, element) { setBackgroundDataSource(element); });
    }

    function setBackgroundDataSource(element) {
        // Cache the object
        var self = $(element || this);
        // Get the background-image
        var background = self.css("background-image");
        // If the background image is anything other than "none"
        if (background !== "none") {
            // Find and slice "url()" to get the pure image URL
            background = background.slice(4, -1).replace(/['"]/g, "");

            var image = images[background];
            if (image) {
                setImageHeight(self, image);
                return;
            }

            // Create new Image instance, store it in the array, and set path to our background
            image = new Image;
            image.src = background;
            images[image.src] = image;

            if (image.complete) {
                setImageHeight(self, image);
            } else {
                image.addEventListener("load", function () { setImageHeight(self, image); });
            }
        }
    }

    function setImageHeight(self, backImage) {
        self.data("image-height", backImage.height);
        UpdateBackground(self, 4);
    }

    //On Scroll event allows you to send "speed" for the parallax on the page to the UpdateBackground Function.
    function GetDivElements() {
        $parallaxDivs.each(function (index, el) {
            UpdateBackground(this, 4);
        });
        $parallaxMobileDivs.each(function (index, el) {
            var hasMobileImage = $(this).attr("data-has-mobile-image");
            if ((typeof hasMobileImage === "undefined") || (hasMobileImage === "true")) {
                UpdateBackground(this, 4);
            } else {
                $(this).css("background-size", "cover");
                $(this).css("background-position-y", 0);
            }
        });
    }

    //Function That Updates the Background-Y property creating the parallx effect on the page.
    function UpdateBackground(that, speed) {
        var divHeight = $(that).outerHeight();
        var positionY = (($(that).offset().top - ($(window).scrollTop() + window.innerHeight)) / speed);

        var imageHeight = $(that).data("image-height");
        if (typeof imageHeight === "undefined") {
            return;
        }

        if (divHeight > imageHeight) {
            $(that).css("background-size", "cover");
            $(that).css("background-position-y", 0);
        } else {
            $(that).css("background-size", "");

            var imageLocation = (divHeight - imageHeight);
            if (imageLocation >= positionY) {
                $(that).css("background-position-y", imageLocation + "px");
            } else if (positionY >= 0) {
                $(that).css("background-position-y", 0 + "px");
            } else {
                $(that).css("background-position-y", positionY + "px");
            }
        }
    }

    $(document).on('lazyloaded', '.parallax-div, .parallax-mobile-div', function (e) {
        if (e.currentTarget === e.target) {
            setBackgroundDataSource(e.target);
        }
    });

    exports.reCalculateImageHeight = reCalculateImageHeight;
    exports.setBackgroundDataSource = setBackgroundDataSource;
});